import NativeClient from "@/client/native-client";

const STORAGE_KEY_SEARCH_KEYWORD = "search-keyword";

// 買い物リストで使用する
const STORAGE_KEY_SHOPPING_LIST = "shopping-list";

export const isSupportLocalStorage = () => {
  if (typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem('dummy', '1');
      if (localStorage.getItem('dummy') === '1') {
        localStorage.removeItem('dummy');
        return true;
      } else {
        return false;
      }
    } catch (e) {
      NativeClient.sendDebugLog("isSupportLocalStorage error:" + e);
      return false;
    }
  } else {
    return false;
  }
}

export const writeSearchKeyword = (value: string) => {
  if (!isSupportLocalStorage()) {
    NativeClient.sendDebugLog("writeSearchKeyword localStorage not support");
    return;
  }
  localStorage.setItem(STORAGE_KEY_SEARCH_KEYWORD, value);
};

export const readSearchKeyword = () => {
  if (!isSupportLocalStorage()) {
    NativeClient.sendDebugLog("readSearchKeyword localStorage not support");
    return "";
  }
  return localStorage.getItem(STORAGE_KEY_SEARCH_KEYWORD);
};

export const deleteSearchKeyword = () => {
  if (!isSupportLocalStorage()) {
    NativeClient.sendDebugLog("deleteSearchKeyword localStorage not support");
    return "";
  }
  return localStorage.removeItem(STORAGE_KEY_SEARCH_KEYWORD);
};

//
// 買い物リスト関連
//

// 買い物リスト手入力一覧保存
export const writeShoppingList = (value: string) => {
  if (!isSupportLocalStorage()) {
    NativeClient.sendDebugLog("writeShoppingList localStorage not support");
    return;
  }
  localStorage.setItem(STORAGE_KEY_SHOPPING_LIST, value);
}

// 買い物リスト手入力一覧取得
export const readShoppingList = () => {
  if (!isSupportLocalStorage()) {
    NativeClient.sendDebugLog("readShoppingList localStorage not support");
    return "";
  }
  localStorage.getItem(STORAGE_KEY_SHOPPING_LIST);
}
